import { confirmDiscard } from "@/lib/unsaved";
import { useNavigate } from "react-router-dom";
import { Crown, CreditCard, LayoutGrid, LogOut, Moon, Sun } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useAuth } from "@/context/AuthContext";
import { useTheme } from "@/lib/theme";

export function AccountMenu({ guildId, onLogout }) {
  const { user } = useAuth();
  const { theme, toggle } = useTheme();
  const navigate = useNavigate();
  const isAdmin = user?.role === "admin" || user?.staff_role;
  const initial = (user?.name || "?").slice(0, 1).toUpperCase();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="account-menu-trigger" aria-label="Account menu" className="flex items-center gap-2 rounded-full border border-zinc-800 p-0.5 pr-0.5 sm:pr-3 hover:bg-zinc-900 transition-colors">
          {user?.avatar ? <img src={user.avatar} alt="" className="w-8 h-8 rounded-full bg-zinc-800" />
            : <span className="w-8 h-8 rounded-full bg-volt/15 text-volt font-semibold text-sm flex items-center justify-center">{initial}</span>}
          <span className="hidden sm:block text-sm font-medium max-w-[120px] truncate">{user?.name}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60" data-testid="account-menu">
        <DropdownMenuLabel>
          <div className="text-sm font-semibold truncate">{user?.name}</div>
          <div className="text-xs text-zinc-500 font-normal truncate">{user?.email}</div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem className="gap-2 cursor-pointer" onSelect={() => confirmDiscard() && navigate("/app")} data-testid="account-menu-servers"><LayoutGrid className="w-4 h-4" /> My servers</DropdownMenuItem>
        {guildId && <DropdownMenuItem className="gap-2 cursor-pointer" onSelect={() => confirmDiscard() && navigate(`/app/g/${guildId}/billing`)} data-testid="account-menu-billing"><CreditCard className="w-4 h-4" /> Billing & plan</DropdownMenuItem>}
        {isAdmin && <DropdownMenuItem className="gap-2 cursor-pointer" onSelect={() => confirmDiscard() && navigate("/admin")} data-testid="account-menu-admin"><Crown className="w-4 h-4" /> Owner Console</DropdownMenuItem>}
        <DropdownMenuItem className="gap-2 cursor-pointer" onSelect={(e) => { e.preventDefault(); toggle(); }} data-testid="account-menu-theme">
          {theme === "light" ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />} {theme === "light" ? "Dark mode" : "Light mode"}
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem className="gap-2 cursor-pointer text-red-400 focus:text-red-400" onSelect={onLogout} data-testid="account-menu-logout"><LogOut className="w-4 h-4" /> Log out</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
